import Icon from '../components/Icon';

const ArrowRec = Icon(
  'arrow-rec',
  <>
    <path d="M6.48 8.125a.75.75 0 0 0 1.06 1.06l3.71-3.708v15.156a.75.75 0 0 0 1.5 0V5.477l3.71 3.709a.75.75 0 1 0 1.06-1.06l-4.99-4.99a.75.75 0 0 0-1.06 0l-4.99 4.99Z" />
  </>
);

export default ArrowRec;
